import { render, staticRenderFns } from "./ImportsLeases.vue?vue&type=template&id=a53c1f70"
import script from "./ImportsLeases.vue?vue&type=script&lang=js"
export * from "./ImportsLeases.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports